import { Component, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-comunicazioni',
  templateUrl: './comunicazioni.component.html',
  styleUrls: ['./comunicazioni.component.css']
})
export class ComunicazioniComponent {
    window:any= <any>window;
    $:any=<any>this.window.$;
    notification:any = {
        danger: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'danger'}}),
        success: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'success'}})
    };
    rand = (num:any = null) => {
        num = num || 12;
        var text = "";
        var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < num; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };
    openModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`).children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'block');
    };
    closeModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`)?.children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'none');
    };

    tags:any = {};
    newsletter:any = {
        title: '',
        messaggio: '',
        type: '',
        allegati: [],
        id: this.rand()
    };
    temp_storico:any = {
        configuration: {
            title: '',
            messaggio: '',
            allegati: [],
            targets: [],
        },
        app: true,
        push: false,
        email: false
    };
    is_editable:any = new Proxy({
        value: false
    }, {
        set: (t, p, v) => {
            if(p == 'value' && !!v) {
                this.temp_storico.configuration.title = this.getComunicazione().configuration.title;
                this.temp_storico.configuration.messaggio = this.getComunicazione().configuration.messaggio;
                this.temp_storico.configuration.allegati.push(...this.getComunicazione().configuration.allegati.map(e => new Object({
                    ...e
                })));
                this.temp_storico.configuration.targets.push(...this.getComunicazione().configuration.targets);
            }
            if(p == 'value' && !v) {
                this.temp_storico = {
                    configuration: {
                        title: '',
                        messaggio: '',
                        allegati: [],
                        targets: [],
                    },
                    app: true,
                    push: false,
                    email: false
                };
            }
            t[p] = v;
            return true;
        }
    })
    getUsersType:any = () => this.window.usher?.getChildren()?.reduce((a:any, b:any) => {
        a = a || [];
        if(!a.includes(b.public_configuration.type)) a.push(b.public_configuration.type);
        return a;
    }, []);

    getGroups = (id:any = undefined) => this.window.usher.get().public_configuration?.groups?.filter(e => !id || e.id == id) || [];

    get = () => this.window.usher?.getChildren()?.filter(e => this.getTypes()?.includes(e.public_configuration.type) || !!e.public_configuration?.groups?.find(g => this.getTypes()?.includes(g.id))) || [];

    updateView:any = () => {
        setTimeout(() => {
            this.current_type = this.queryparams()['comunicazioni-type'] || 'comunicazioni';

            if(!this.queryparams()['type']) {
                this.closeModal('#comunicazioneModal');
                this.closeModal('#deleteComunicazioneModal');
                this.is_editable.value = false;
            } 
            if(this.queryparams()['type'] == 'delete' && !!this.queryparams()['comunicazione']) {
                this.closeModal('#comunicazioneModal');
                this.openModal('#deleteComunicazioneModal');
            }
            if(this.queryparams()['type'] == 'update' && !!this.queryparams()['comunicazione']) {
                this.closeModal('#deleteComunicazioneModal');
                this.openModal('#comunicazioneModal');
            }

            this.cd.detectChanges();
        });
    };

    filter:any = {
        email: false,
        push: false,
        app: false
    };

    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });
    current_type:any = 'comunicazioni';
    constructor(
        private cd: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router,
        private zone: NgZone
    ) {
        route.queryParams.subscribe((p:any) => this.updateView());
    }

    ngAfterViewInit() {
        this.window.scrollTo(0,0);
        this.window.usher.element.addEventListener("change", this.updateView.bind(this));
    };

    ngOnDestroy() {
        this.window.usher.element.removeEventListener("change", this.updateView.bind(this));
    };

    onChangeType = (event:any, type:any) => this.router.navigate(['/comunicazioni'], { queryParams: this.changeQueryParam({ [type]: !!event?.target?.checked }) });

    getTypes:any = () => Array.from(this.window.document.querySelectorAll('#user_type_wrapper input')).reduce((a:any, b:any) => {
        a = a || [];
        let type = b.name.replace("check_", "");
        if(b.checked && !a.includes(type)) a.push(type);
        if(!b.checked && !!a.includes(type)) a = a.filter(e => e != type);
        return a;
    }, []);

    initModel = () => {
        this.newsletter = {
            title: '',
            messaggio: '',
            type: '',
            allegati: [],
            id: this.rand()
        };
        this.temp_storico = {
            app: true,
            push: false,
            email: false
        };
    };

    checkAll = () => this.get().forEach(u => this.window.document.querySelector(`#check_user_${u.public_token}`).checked = true);

    uncheckAll = () => this.get().forEach(u => this.window.document.querySelector(`#check_user_${u.public_token}`).checked = false);

    check = (obj:any = {}) => {
        /*if(!this.newsletter.type) {
        this.notification.danger({text: "Attenzione! Inserire il tipo di comunicazione"});
        return false;
        }*/
        if(!obj.title) {
            this.notification.danger({text: "Attenzione! Inserire il titolo"});
            return false;
        }
        if(!obj.messaggio) {
            this.notification.danger({text: "Attenzione! Inserire il corpo del messaggio"});
            return false;
        }
        return true;
    };

    // FUNZIONE PER INVIARE LE COMUNICAZIONI/STORICO
    send = async (obj:any = undefined) => {
        if(!this.check(obj?.configuration || this.newsletter)) return;
        try {
            let array_tosend = this.get().filter(e => this.window.document.querySelector(`#check_user_${e.public_token}`).checked == true),
                obj_tosend = {
                    targets: array_tosend.map(e => e.public_token),
                    targets_email: array_tosend.map(e => e.email),
                    title: this.newsletter.title,
                    messaggio: this.newsletter.messaggio,
                    allegati: this.newsletter.allegati,
                    email: !!this.filter.email,
                    timeline: !!this.filter.app,
                    push: !!this.filter.push,
                    id: this.newsletter.id
                };
            if(!!obj) obj_tosend = {
                targets: obj.configuration.targets,
                targets_email: !!this.temp_storico.email ? obj.configuration.targets : [],
                title: obj.configuration.title,
                messaggio: obj.configuration.messaggio,
                allegati: obj.configuration.allegati,
                email: !!this.temp_storico.email,
                timeline: true,
                push: !!this.temp_storico.push,
                id: this.newsletter.id
            };
            await this.window.sf.utils.$http({
                    url : `${this.window.appInfo.url_php}/endpoint.php/comunicazioni`,
                    method : "POST",
                    headers: { 'Content-Type': 'application/json; charset=utf-8' },
                    data : {
                        private_token: this.window.usher.get().private_token,
                        ...obj_tosend
                    }
            });
            if(!!obj) this.handleModal(undefined, undefined);
            this.initModel();
            this.notification.success({text: 'Comunicazione inviata correttamente.'});
            return;
        } catch(e) {
            console.log(e);
            this.notification.danger({text: "Errore! Riprova più tardi."});
        }
    };

    getDocuments = (input:any = undefined, collection:any = this.newsletter.allegati) => this.zone.run(async () => {
        this.window.flowup.signal.emit({name: 'get-files', detail: {
            event: input,
            callback: (parsed_files) => {
                this.window.flowup.signal.emit({name: 'upload-files', detail: {
                    collection: parsed_files,
                    callback: (sent) => {
                        collection.push(...sent.map(s => new Object({
                            ...s,
                            type: 'avviso',
                            target: this.newsletter.id,
                            owner: this.window.usher.getPublicToken()
                        })));
                        this.updateView();
                        return this.notification.success({text: "Documenti caricati con successo."});
                    },
                    error: (file) => {
                        return this.notification.danger({text: `Errore nel caricamento del file ${file.filename}`});
                    }
                }});
            }
        }});
    });
    
    /*****************GESTIONE DELLO STORICO DELLE COMUNICAZIONI*****************/

    getStorico = (pt:any = undefined) => this.window.emitter.getEvents().filter(e => e.configuration.type == 'comunicazione' && (!pt || e.public_token == pt));

    handleModal = (pt:any = undefined, type:any = undefined) => {
        this.router.navigate([`/comunicazioni`], { queryParams: this.changeQueryParam({ "comunicazione" : pt, "type" : type }) });
    };

    getComunicazione = () => {
        if(!!this.queryparams()['comunicazione']) return !!this.is_editable.value ? this.temp_storico : (this.getStorico(this.queryparams()['comunicazione'])[0] || {configuration: {allegati: []}});
        return {configuration: {allegati: []}};
    };

    getFormatDate = (date:any) => this.window.moment(date).format("DD/MM/YYYY");

    getFormatTime = (date:any) =>  this.window.moment(date).format("HH:mm");

    getLink = (name:any) => `${this.window.appInfo.url_media}/get.php?private_token=${this.window.usher.getPrivateToken()}&name=${name}`;

    deleteComunicazione = async () => {
        if(!this.getComunicazione().public_token || this.queryparams()['type'] != 'delete') return;
        try {
            await this.window.sf.utils.$http({
                url : `${this.window.appInfo.url_php}/endpoint.php/comunicazioni`,
                method : "DELETE",
                headers: { 'Content-Type': 'application/json; charset=utf-8' },
                data : {
                    private_token: this.window.usher.get().private_token,
                    public_token: this.getComunicazione().public_token
                }
            });
            this.handleModal(undefined, undefined);
            return this.notification.success({text: "Comunicazione eliminata con successo."});
        } catch(e) {
            console.log(e);
            return this.notification.danger({text: "Errore. Riprova più tardi."});
        }
    };

    addPartecipante = (pt:any = undefined) => {
        if(!pt) return;
        if(this.getComunicazione().configuration.targets.includes(pt)) return; // this.notification.danger({text: "Errore. Riprova più tardi."});
        this.getComunicazione().configuration.targets.push(pt);
    };

    // TAGS
    addTag = (document) => {
        if(!!document.tags?.find(e => e.toLowerCase() == this.tags[document.name]?.toLowerCase())) return this.notification.danger({text: "Attenzione! Tag già inserito"});
        document.tags?.push(this.tags[document.name]?.toLowerCase());
        this.tags[document.name] = "";
    };
}